const timeAgo = ts => (new Date() - new Date(ts)) / (1000 * 60);

export const getMinutes = ts => (Math.floor(timeAgo(ts) % 60) < 10
    ? "0"
    : "") + Math.floor(timeAgo(ts) % 60)
export const getHours = ts => (Math.floor(timeAgo(ts) / 60) < 10
    ? "0"
    : "") + Math.floor(timeAgo(ts) / 60)


// WEBPACK FOOTER //
// ./src/ui/item/functions/time.js